import React, { PureComponent } from 'react';
import { Div } from 'Common/components/Atoms/Div';
import { Flex } from 'Common/components/Atoms/Flex';
import { FontIcon } from 'Common/components/Atoms/FontIcon';
import { Link } from 'Common/components/Atoms/Link';
import { Tooltip } from 'Common/components/Atoms/Tooltip';
import { HOME_CLICK, logEvent } from '../../utils/analytics';
import { faQuestionCircle } from '@fortawesome/pro-light-svg-icons';
import AccountSelector from '../AccountSelector';
import { NavLink } from 'react-router-dom';
import OrganizationSelector from '../../components/OrganizationSelector';
import ProjectSelector from '../ProjectSelector';
import { actions as accountActions } from '../../reducers/Account';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { idForProvider } from '../../utils/providerHelpers';
import { actions as organizationActions } from '../../reducers/organizations';
import { selectors } from '../../reducers/projects';
import {
  accountOrganizationsSelector,
  isH1AssessmentsUser,
  isH1SecurityUser,
} from '../../selectors/Account';
import { Theme } from '@mui/material/styles';
import withStyles from '@mui/styles/withStyles';
import withTheme from '@mui/styles/withTheme';
import primaryLogo from '../../resources/full-logo.svg';
import secondaryLogo from '../../resources/secondary-logo.svg';
import { Organization } from '../../models/Organization';
import { Project } from '../../models/Project';
import { User } from '../../models/User';
import { Integration } from '../../models/Integration';
import { State } from '../../reducers/State';
import { projectSelector } from '../../selectors/Projects';
import {
  isH1SecurityOrganization,
  organizationSelector,
} from '../../selectors/Organization';
import ThemeSelector from '../ThemeSelector';
import SecurityLogo from '../SecurityFixReview/SecurityLogo';

const styles = (theme: Theme) => {
  return {
    header: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      background: theme.palette.background.default,
      boxSizing: 'border-box',
      height: '50px',
      padding: '9px 20px',
      flexShrink: 0,
      zIndex: theme.zIndex.appBar,
      borderBottom: `solid 1px ${theme.palette.divider}`,
    },
    logo: {
      background: `transparent url(${
        theme.palette.mode === 'light' ? primaryLogo : secondaryLogo
      }) no-repeat`,
      width: '170px',
      height: '31px',
    },
  };
};

interface Props {
  organization?: Organization;
  classes: {
    [key: string]: string;
  };
  location: {
    pathname: string;
  };
  integration?: Integration;
  organizations?: Organization[];
  project?: Project;
  projects?: Project[];
  theme: Theme;
  user: User;
  isH1AssessmentsUser: boolean;
  isH1SecurityUser: boolean;
  isH1SecurityOrg: boolean;
}

// TODO: Refactor to use functional component & MUI styled()
export class HeaderBar extends PureComponent<Props> {
  render(): JSX.Element {
    const {
      classes,
      location,
      organization,
      organizations,
      project,
      theme,
      user,
      isH1AssessmentsUser,
      isH1SecurityUser,
      isH1SecurityOrg,
    } = this.props;

    const showProjectsSelector = !isH1AssessmentsUser && !isH1SecurityOrg;

    return (
      <header className={classes.header}>
        <Flex width="100%" alignItems="center">
          <Div>
            <NavLink
              onClick={() => {
                logEvent(HOME_CLICK);
              }}
              to={
                organization
                  ? `/dash/${idForProvider(organization.provider)}/${
                      organization.slug
                    }`
                  : '/dash'
              }
            >
              {isH1SecurityUser ? (
                <Div mr={3}>
                  <SecurityLogo />
                </Div>
              ) : (
                <div className={classes.logo} data-testid="pullrequest-logo" />
              )}
            </NavLink>
          </Div>
          <Flex alignItems="center" flexGrow={1}>
            {organizations.length > 0 && (
              <OrganizationSelector
                location={location}
                organization={organization}
                organizations={organizations}
              />
            )}
            {organization && showProjectsSelector && (
              <ProjectSelector
                location={location}
                organization={organization}
                project={project}
              />
            )}
          </Flex>
          <ThemeSelector />
          <div>
            <Tooltip title="Documentation" placement="bottom">
              <Link
                href="https://docs.pullrequest.com/pullrequest-docs/"
                target="_blank"
              >
                <FontIcon
                  icon={faQuestionCircle}
                  color={theme.palette.text.primary}
                  size="lg"
                />
              </Link>
            </Tooltip>
          </div>
          <Div my={0.5}>
            <AccountSelector organization={organization} user={user} />
          </Div>
        </Flex>
      </header>
    );
  }
}

function mapStateToProps(state: State) {
  const organization = organizationSelector(state);
  const organizations = accountOrganizationsSelector(state);
  const projects = organization
    ? selectors.projectsForOrganization(
        state,
        organization.providerId,
        organization.slug
      )
    : null;
  const project = projectSelector(state);
  return {
    organization,
    organizations,
    project,
    projects,
    isH1AssessmentsUser: isH1AssessmentsUser(state),
    isH1SecurityUser: isH1SecurityUser(state),
    isH1SecurityOrg: isH1SecurityOrganization(state),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { ...accountActions, ...organizationActions },
    dispatch
  );
}

export default withTheme(
  withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(HeaderBar))
);
